<script>
import { $vfm } from 'vue-final-modal';

export default {
  props: ['mobile'],
  methods: {
    show() {
      $vfm.show({
        component: 'RedeemModal',
        on: {
          confirm(code) {
            close();
            const locale =
              document
                .querySelector('meta[name="current-locale"]')
                ?.getAttribute('content') || 'ru';
            window.location.href = `/${encodeURIComponent(code)}?locale=${encodeURIComponent(locale)}`;
          },
          cancel(close) {
            close();
          },
        }
      });
    }
  }
}
</script>

<template>
  <template v-if="mobile">
    <button class="mobile-downl" type="button" @click.stop.prepend="show">
      <img src="@/images/img/mobile_download.png">
    </button>
  </template>

  <template v-else>
    <button class="header-action button button_plain button_icon" @click.stop.prepend="show">
      <img src="@/images/img/download.png" alt="">
    </button>
  </template>
</template>
